import { useContextState } from '../../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    content: {
      display: 'flex',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
      border: `1px solid ${colors.color39}`,
      borderRadius: '0px',
    },
    leftPanel: {
      display: 'flex',
      flexDirection: 'column',
      paddingBottom: '8px',
      borderRight: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      width: '35%',
      overflow: 'hidden',
      flexShrink: 0,
      minHeight: 0,
    },
    panelHeader: {
      padding: '8px 20px',
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
      backgroundColor: `${colors.color25}50`,
      borderBottom: `1px solid ${colors.color39}`,
    },
    typesList: {
      display: 'flex',
      flexDirection: 'column',
      padding: '12px',
      gap: '8px',
      overflowY: 'auto',
      flex: 1,
      minHeight: 0,
    },
    typeRow: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      padding: '5px 9px',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      cursor: 'pointer',
      color: colors.color13,
      backgroundColor: colors.color5,
    },
    typeRowActive: {
      color: colors.color4,
      borderColor: colors.color4,
    },
    typeLabel: {
      fontSize: '16px',
      color: 'inherit',
    },
    rightPanel: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      padding: '8px 20px 16px',
      overflow: 'hidden',
      minHeight: 0,
      gap: '16px',
    },
    rightContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflowY: 'auto',
      gap: '16px',
    },
    dropzoneWrapper: {
      flexShrink: 0,
    },
    filesContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
    },
    commentsContainer: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      gap: '8px',
    },
    rightHeader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '16px',
    },
    rightTitle: {
      fontSize: '16px',
      fontWeight: '600',
      color: colors.color13,
    },
    viewToggle: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    toggleButton: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      padding: '4px 8px',
      color: colors.color10,
      cursor: 'pointer',
      borderRadius: '4px',
      transition: 'all 0.2s ease',
    },
    toggleButtonActive: {
      color: colors.color4,
    },
    toggleLabel: {
      fontSize: '13px',
      color: 'inherit',
      fontWeight: '500',
    },
    dropzone: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '4px',
      padding: '18px 24px',
      border: `2px dotted ${colors.color39}`,
      borderRadius: '2px',
      backgroundColor: colors.color5,
      cursor: 'pointer',
      transition: 'all 0.2s ease',
    },
    dropzoneActive: {
      borderColor: colors.color4,
      backgroundColor: `${colors.color4}08`,
    },
    dropzoneContent: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '14px',
    },
    dropzoneIcon: {
      display: 'flex',
      alignItems: 'center',
      color: `${colors.color10}95`,
      '& .MuiBox-root': { width: '32px', height: '32px' },
      '& .MuiSvgIcon-root': { fontSize: '32px' }
    },
    dropzoneText: {
      fontSize: '14px',
      color: colors.color10,
    },
    dropzoneFormats: {
      fontSize: '12px',
      color: colors.color10,
    },
    filesSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
    filesList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    fileCardList: {
      display: 'flex',
      alignItems: 'center',
      padding: '10px 14px',
      borderRadius: '2px',
      backgroundColor: colors.color25,
    },
    filesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
      gap: '14px',
    },
    fileCardGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: '8px',
      overflow: 'hidden',
      position: 'relative',
      boxShadow: '0 3px 6px rgba(0, 0, 0, 0.12)',
      '&:hover .MuiBox-root[data-overlay="true"]': {
        opacity: 0.7,
      },
    },
    fileCardGridDocument: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: `1px solid ${colors.color39}`,
      borderRadius: '4px',
      backgroundColor: colors.color5,
      overflow: 'hidden',
      position: 'relative',
    },
    filePreviewGrid: {
      width: '100%',
      aspectRatio: '1 / 1',
      objectFit: 'cover',
      borderRadius: '8px',
    },
    filePreviewGridOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      opacity: 0,
      transition: 'opacity 0.2s ease',
    },
    deleteButtonGridHover: {
      color: colors.color19,
      backgroundColor: 'transparent',
      padding: '0',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '& .MuiSvgIcon-root': { fontSize: '28px' }
    },
    fileIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      aspectRatio: '1 / 1',
      color: colors.color10,
      fontSize: '40px',
      backgroundColor: colors.color14,
      borderRadius: '8px',
    },
    fileIconDocument: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      py: '12px',
      color: `${colors.color10}95`,
      backgroundColor: `${colors.color25}40`,
      '& .MuiSvgIcon-root': { fontSize: '48px' }
    },
    fileNameGrid: {
      fontSize: '13px',
      color: colors.color22,
      textAlign: 'center',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    fileNameWithAction: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '4px',
      width: '100%',
      padding: '6px 4px 6px 7px',
      borderTop: `1px solid ${colors.color39}`,
    },
    deleteButtonGrid: {
      color: colors.color19,
      padding: '0',
    },
    fileNameList: {
      fontSize: '14px',
      color: colors.color22,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      flex: 1,
      minWidth: 0,
    },
    fileActions: {
      display: 'flex',
      alignItems: 'center',
      gap: '4px',
      flexShrink: 0,
    },
    deleteButton: {
      color: colors.color19,
      padding: '4px',
      minWidth: 'auto',
    },
    emptyState: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flex: 1,
      minHeight: 0,
    },
    emptyStateText: {
      fontSize: '16px',
      color: colors.color22,
    },
    commentInput: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '10px 14px',
      border: `2px dotted ${colors.color39}`,
      borderRadius: '4px',
      backgroundColor: colors.color5,
      flexShrink: 0,
    },
    commentTextField: {
      '& .MuiOutlinedInput-root': {
        '& fieldset': {
          borderRadius: '2px',
        },
      },
    },
    commentAddButton: {
      alignSelf: 'flex-end',
      fontSize: '14px',
      color: colors.color4,
      cursor: 'pointer',
      fontWeight: '500',
      py: '6px',
    },
    commentAddButtonDisabled: {
      color: colors.color10,
      cursor: 'default',
    },
    commentsList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
    },
    commentCard: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      padding: '10px 14px',
      borderRadius: '2px',
      backgroundColor: colors.color25,
    },
    commentIcon: {
      display: 'flex',
      alignItems: 'center',
      color: colors.color22,
      fontSize: '20px',
    },
    commentText: {
      fontSize: '14px',
      color: colors.color22,
      flex: 1,
      wordBreak: 'break-all',
      overflowWrap: 'anywhere',
      minWidth: 0,
    },
    signatureInput: {
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      padding: '10px 14px',
      border: `2px dotted ${colors.color39}`,
      borderRadius: '4px',
      backgroundColor: colors.color5,
      flexShrink: 0,
    },
    signatureCanvas: {
      display: 'flex',
      width: '100%',
      backgroundColor: colors.color5,
      border: `1px solid ${colors.color39}`,
      borderRadius: '2px',
      overflow: 'hidden',
      '& canvas': {
        width: '100% !important',
        height: '140px !important',
      },
    },
    signatureActions: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      gap: '16px',
    },
    signatureAddButton: {
      fontSize: '14px',
      color: colors.color4,
      cursor: 'pointer',
      fontWeight: '500',
      py: '6px',
      userSelect: 'none',
    },
    signatureAddButtonDisabled: {
      color: colors.color10,
      cursor: 'default',
    },
    signatureClearButton: {
      fontSize: '14px',
      color: colors.color10,
      cursor: 'pointer',
      fontWeight: '500',
      py: '6px',
      userSelect: 'none',
    },
    signatureClearButtonDisabled: {
      color: colors.color10,
      cursor: 'default',
      opacity: 0.6,
    },
    fileState: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexShrink: 0,
    },
    fileStateText: {
      fontSize: '12px',
      color: colors.color10,
    },
    fileStateError: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
      flexShrink: 0,
    },
    fileErrorText: {
      fontSize: '12px',
      color: colors.color19,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '180px',
    },
    fileStateGrid: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: '8px',
      width: '100%',
      aspectRatio: '1 / 1',
      backgroundColor: `${colors.color25}80`,
      borderRadius: '8px',
    },
    fileStateGridError: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      padding: '8px',
    },
    fileGridActionsOverlay: {
      position: 'absolute',
      top: '4px',
      right: '4px',
      display: 'flex',
      gap: '2px',
      zIndex: 1,
    },
    fileCardError: {
      border: `1px solid ${colors.color19}`,
    },
    fileCardListError: {
      border: `1px solid ${colors.color19}`,
      backgroundColor: `${colors.color19}08`,
    },
    retryButton: {
      color: colors.color4,
      padding: '4px',
      minWidth: 'auto',
    },
  }
}
